import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './BarcodeParsing.frontend.types'

@Injectable({ providedIn: 'root' })
export class BarcodeParsing_get_serial_number_code_by_parsedValuesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { parsedValues: { gtin?: string, serialNumber?: string, expirationDate?: string, lotNumber?: string, sscc?: string, varCount?: string } }): Promise<{ serialNumberCode?: string, reasons?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parsedValues)) {
      missingRequiredInParams.push('\'parsedValues\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/BarcodeParsing/functions/get_serial_number_code_by_parsedValues`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

